import { AnswerFormat, Assessment, StudentAssessmentOutcome } from 'types';
import * as Yup from 'yup';
import { translate } from '@lwtears/lwt-common-frontend/lib/@common/util/i18n-util';

const t = (key) => translate('ui.assessments', key);

export const convertPointsToScore = (points) => {
  return points === undefined || points === null || points === ''
    ? null
    : points === 0
    ? 1
    : points === 1 || points === 2
    ? 2
    : 3;
};

export const buildDomains = (assessment) => {
  const domains: { title: string; steps: number; id: number }[] =
    assessment?.assessmentDomains?.map((domain) => ({
      title: domain.domain.title,
      id: domain.domain.id,
      steps: domain.assessmentSections.length,
    })) || [];
  domains.unshift({ title: t('overview'), steps: 1, id: -1 });
  return domains;
};

export const buildInitialAssessmentValues = (
  outcomes: StudentAssessmentOutcome[] = [],
  assessment: Assessment,
  studentId: number,
  validationSchema
) => {
  const initialValues: { [key: string]: any } = {};

  assessment.assessmentDomains.map((domain) =>
    domain.assessmentSections.forEach((section) => {
      const sectionQuestionsSchema = {};
      const initialValueSchema = {};

      section.assessmentSectionQuestions.forEach((question) => {
        sectionQuestionsSchema[question.assessmentQuestion.id] = Yup.number().oneOf(
          question.assessmentQuestion.answerType.options.map((option) => option.id)
        );

        const outcome = outcomes.find(
          (o) =>
            o.assessmentQuestionId === question.assessmentQuestion.id && o.studentId === studentId
        );

        initialValueSchema[question.assessmentQuestion.id] = outcome
          ? outcome.answerTypeOptionId?.toString()
          : question.assessmentQuestion.answerType.format === AnswerFormat.CharacterChart
          ? question.assessmentQuestion.answerType.options[0].id.toString()
          : '';
      });

      validationSchema[section.id] = Yup.object().shape(sectionQuestionsSchema);
      initialValues[section.id] = initialValueSchema;
    })
  );

  return initialValues;
};
